import Slider from '../slider';

export default (element, data) => {
  const { visibleTiles } = data;
  const visibleTilesConverted = visibleTiles === 'three' ? 3 : 4;
  // eslint-disable-next-line no-unused-vars
  let slider = null;

  const initSlider = () => {
    if (element.querySelector('[data-category-slider]')) {
      const prevEl = element.querySelector('[data-category-slider-prev]');
      const nextEl = element.querySelector('[data-category-slider-next]');
      const paginationEl = element.querySelector('[data-category-slider-pagination]'); 

      slider = new Slider({
        el: element.querySelector('[data-category-slider]'),
        options: {
          slidesPerView: 2,
          spaceBetween: 10,
          loop: true,
          breakpoints: {
            1024: {
              slidesPerView: visibleTilesConverted
            }
          },
          navigation: {
            nextEl,
            prevEl,
          },
          pagination: { 
            el: paginationEl,
            clickable: true,
          },
           on: {
            init(swiperInstance) {
             requestAnimationFrame(() => updateA11y(swiperInstance))
            },
            slideChangeTransitionEnd(swiperInstance) {
             requestAnimationFrame(() => updateA11y(swiperInstance))
            },
            resize(swiperInstance) {
              requestAnimationFrame(() => updateA11y(swiperInstance))
            },
          },
        },
      });
    }

      function updateA11y(swiperSlider) {
        if (!swiperSlider || !swiperSlider.slides || !swiperSlider.el) return;

        const slides = Array.from(swiperSlider.slides);
        const total = slides.length;
        const {slidesPerView} = swiperSlider.params;
        const visibleCount = Math.ceil(typeof slidesPerView === 'number' ? slidesPerView : 1); 
        const active = swiperSlider.activeIndex;


        let startPos;
        let endPos;
        if (swiperSlider.params.centeredSlides) {
          const half = Math.floor((visibleCount - 1) / 2);
          startPos = active - half;
          endPos = startPos + visibleCount - 1;
        } else {
          startPos = active;
          endPos = startPos + visibleCount - 1;
        }


        const visibleDataIdx = new Set();
        // eslint-disable-next-line no-plusplus
        for (let i = startPos; i <= endPos; i++) { 
          const pos = ((i % total) + total) % total;
          const dataIdx = slides[pos].getAttribute('data-swiper-slide-index');
          visibleDataIdx.add(dataIdx != null ? dataIdx : String(pos));
        }


        const containerRect = swiperSlider.el.getBoundingClientRect();
        const TOL = 1; 

        slides.forEach(slide => {
          const slideIndexOf = slide.getAttribute('data-swiper-slide-index') ?? String(slides.indexOf(slide));
          const byIndex = visibleDataIdx.has(slideIndexOf);

      
          const rect = slide.getBoundingClientRect();
          const intersects = !(rect.right <= containerRect.left + TOL || 
            rect.left >= containerRect.right - TOL);

          const isVisible = byIndex && intersects;

          slide.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
          slide.setAttribute('tabindex', isVisible ? 0 : -1);
        });

      }

  };

  initSlider();
};
